import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Switch } from 'pretty-checkbox-react';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';
import ModalPreviewItem from '../../components/ModalPreviewItem';
import Preview from '../Clients/Preview';

import {
  getAllSchedules,
  removeSchedules,
  restoreSchedules,
  closeSchedules,
  cloneSchedules
} from '../../redux/actions/schedules';
import { getAllUsers } from '../../redux/actions/users';
import { getAllClients } from '../../redux/actions/clients';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import ModalCloseSchedule from '../../components/ModalCloseSchedule';
import ModalCloneItem from '../../components/ModalCloneItem';
import searchForPermissions from '../../utils/searchForPermissions';

function List (props) {
  const [showAllSchedules, setShowAllSchedules] = useState(false);
  const schedules = useSelector(state => state.schedules);
  const dispatch = useDispatch();
  const users = useSelector(state => state.users.data);
  const clients = useSelector(state => state.clients.data);
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = schedules.data
    .map(item => {
      const employees = users
        .filter(user => item.employees.includes(user._id))
        .map(user => ({ _id: user._id, name: user.name }));
      const clts = clients.filter(client => item.clients.includes(client._id));

      return item.active || currentPermissions.options.r
        ? { ...item, clients: clts, employees }
        : false;
    })
    .filter(item => (!item.completed || showAllSchedules ? item : false));

  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeSchedules(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreSchedules({ _id: id, active: true }));
  };
  const [showModalCloseSchedule, setShowModalCloseSchedule] = useState(false);
  const [idItemWillCloseSchedule, setIdItemWillCloseSchedule] = useState('');
  const [titleItemWillCloseSchedule, setTitleItemWillCloseSchedule] = useState(
    ''
  );
  const handleModalConfirmYesCloseSchedule = id => {
    setShowModalCloseSchedule(false);
    dispatch(closeSchedules({ _id: id, completed: true }));
  };
  const [showModalClone, setShowModalClone] = useState(false);
  const [dataItemWillClone, setDataItemWillClone] = useState('');
  const [nameItemWillClone, setNameItemWillClone] = useState('');
  const handleModalConfirmYesClone = data => {
    setShowModalClone(false);
    const dateStart = new Date();
    const dateEnd = new Date();
    dateEnd.setMinutes(dateEnd.getMinutes() + 30);
    const newData = {
      ...data,
      clients: data.clients.map(item => item._id),
      employees: data.employees.map(item => item._id),
      typeSchedule: data.typeSchedule._id,
      completed: false,
      dateStart,
      dateEnd
    };
    delete newData._id;
    dispatch(cloneSchedules(newData));
  };
  const [showModalPreviewItem, setShowModalPreviewItem] = useState(false);
  const [dataModalPreview, setDataModalPreview] = useState([]);

  useEffect(() => {
    dispatch(getAllUsers());
    dispatch(getAllSchedules({ company }));
    dispatch(getAllClients({ company }));
  }, [dispatch]);

  const columns = [
    {
      title: 'Título',
      data: 'title',
      render: data => data || '---'
    },
    {
      title: 'Tipo',
      data: 'typeSchedule',
      render: data => data.name || '---'
    },
    {
      title: 'Início',
      data: 'dateStart',
      render: (data, type) => {
        if (data) {
          if (type === 'display' || type === 'filter') {
            return new Date(data).toLocaleString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Término',
      data: 'dateEnd',
      render: (data, type) => {
        if (data) {
          if (type === 'display' || type === 'filter') {
            return new Date(data).toLocaleString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Status',
      data: 'completed',
      render: data => (data ? 'Fechado' : 'Aberto')
    },
    {
      title: 'Colaboradores',
      data: 'employees',
      render: data => (data ? data.map(item => item.name).join(', ') : '---')
    },
    {
      title: 'Clientes',
      data: 'clients',
      render: data =>
        data && data.length ? data.map(item => item.name).join(', ') : '---'
    },
    {
      title: 'Local',
      data: 'local',
      render: data => data || '---'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
            ${
              !(currentPermissions.options.l && currentPermissions.options.u)
                ? ''
                : `<button id="${data}" type="button" title="Terminar Agendamento" ${
                    obj.completed ? 'disabled=""' : ''
                  } class="btn btn-dark button-action button-action-options m-1 rounded"><i class="fa fa-stop-circle"></i></button>`
            }
            ${
              !(currentPermissions.options.l && currentPermissions.options.c)
                ? ''
                : `<button id="${data}" type="button" title="Clonar Agendamento" class="btn btn-primary button-action button-action-clone m-1 rounded"><i class="fa fa-copy"></i></button>`
            }
            ${
              !currentPermissions.options.l
                ? ''
                : `<button id="${data}" type="button" title="Visualizar Cliente" class="btn btn-success button-action button-action-generic rounded"><i class="fa fa-address-book"></i></button>`
            }
            ${
              !(currentPermissions.options.l && currentPermissions.options.u)
                ? ''
                : `<button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>`
            }
            ${
              !obj.active ||
              !(currentPermissions.options.l && currentPermissions.options.d)
                ? ''
                : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
            }
            ${
              obj.active ||
              !(currentPermissions.options.l && currentPermissions.options.r)
                ? ''
                : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
            }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/schedules/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.title);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.title);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  const handleOptionsButton = dataRow => {
    setTitleItemWillCloseSchedule(dataRow.title);
    setIdItemWillCloseSchedule(dataRow._id);
    setShowModalCloseSchedule(true);
  };

  const handleCloneButton = dataRow => {
    setNameItemWillClone(dataRow.title);
    setDataItemWillClone(dataRow);
    setShowModalClone(true);
  };

  const handleGenericButton = dataRow => {
    const { clients } = dataRow;
    setDataModalPreview([...clients]);
    setShowModalPreviewItem(true);
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir o agendamento'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar o agendamento'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <ModalCloseSchedule
        showModal={showModalCloseSchedule}
        handleModalClose={() => setShowModalCloseSchedule(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesCloseSchedule(idItemWillCloseSchedule)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja finalizar o agendamento'}
        titleItemWillClosed={titleItemWillCloseSchedule}
      />
      <ModalCloneItem
        showModal={showModalClone}
        handleModalClose={() => setShowModalClone(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesClone(dataItemWillClone)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja clonar o agendamento'}
        nameItemWillClone={nameItemWillClone}
      />
      <ModalPreviewItem
        showModal={showModalPreviewItem}
        handleModalClose={() => setShowModalPreviewItem(false)}
        component={() => {
          return dataModalPreview.map((data, index) => {
            return <Preview key={index} data={data} />;
          });
        }}
      />
      <TableHeader
        title={'Agendamentos'}
        url={'/schedules/add'}
        updateList={() => {
          dispatch(getAllSchedules({ company }));
          dispatch(getAllClients({ company }));
        }}
        isFetching={schedules.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {currentPermissions.options.l && (
        <div className="checkbox mb-3">
          <Switch
            type="checkbox"
            color="success"
            onChange={() => setShowAllSchedules(!showAllSchedules)}
            checked={showAllSchedules}
          >
            <span className="font-weight-bold text-danger">
              Mostrar todos os agendamentos
            </span>
          </Switch>
        </div>
      )}
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns}
          buttons={buttons}
          order={[[2, 'asc']]}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
          handleOptionsButton={handleOptionsButton}
          handleCloneButton={handleCloneButton}
          handleGenericButton={handleGenericButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
